import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  const handleScrollToPricing = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById('pricing');
    if (!target) return;
    const startY = window.scrollY;
    const endY = target.getBoundingClientRect().top + window.scrollY;
    const distance = endY - startY;
    const duration = 2200; // ms — lento y suave
    let startTime: number | null = null;
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const step = (timestamp: number) => {
      if (startTime === null) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, startY + distance * easeInOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  return <section className="bg-cream pt-5 pb-6 md:pt-10 md:pb-10 px-4 relative overflow-hidden" data-id="element-111">
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-gold/10 rounded-full blur-[140px] pointer-events-none" data-id="element-112"></div>

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-114">
          <span className="inline-block text-[10px] md:text-sm text-ink bg-surface border border-border rounded-full px-3 py-0.5 md:px-4 md:py-1 mb-2 md:mb-3 font-medium shadow-sm" data-id="element-115">
            🧠 EUREKALABS.STORE
          </span>
          <h1 className="font-bold text-ink mb-1.5 md:mb-2 text-sm sm:text-xl md:text-4xl leading-tight whitespace-nowrap px-2" data-id="element-116">
            MENOS IMPROVISACIÓN + MÁS CRITERIO CLÍNICO
          </h1>
          <p className="text-gold font-bold text-lg md:text-2xl mb-0.5 tracking-wide font-serif" data-id="element-117">
            CÓDIGO ALIMENTARIO
          </p>
          <p className="text-muted text-[11px] md:text-sm max-w-2xl mx-auto font-medium" data-id="element-118">
            El Sistema Maestro de Estrategias y Protocolos de Intervención para
            Terapeutas
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="my-2 md:my-4 flex justify-center" data-id="element-119">
          <img src="https://cdn.magicpatterns.com/uploads/4bVEsYsGuM1p2npGDeTrT7/Diseno_sin_titulo_(15).png" alt="Código Alimentario — Sistema Maestro de Estrategias y Protocolos de Intervención" className="w-full max-w-[300px] md:max-w-[440px] mx-auto drop-shadow-[0_25px_60px_rgba(0,0,0,0.25)]" data-id="element-120" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} data-id="element-121">
          <p className="text-ink text-xs sm:text-base md:text-2xl max-w-2xl mx-auto mb-1.5 md:mb-3 font-bold font-serif px-2 whitespace-nowrap" data-id="element-122">
            ¿Llegás a tu sesión sin saber qué probar después?
          </p>
          <p className="text-muted text-xs md:text-lg max-w-2xl mx-auto mb-3 md:mb-6 px-2 leading-snug" data-id="element-123">
            La guía definitiva para dejar de adivinar en cada sesión y empezar a
            intervenir con un sistema que genera avances reales en tus casos de
            alimentación infantil.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="max-w-2xl mx-auto" data-id="element-124">
          <a href="#pricing" onClick={handleScrollToPricing} className="inline-block bg-gradient-to-b from-[#F2D87A] via-[#C9A84C] to-[#8A6E2A] hover:from-[#F5DE8C] hover:via-[#D4B45A] hover:to-[#9A7E36] text-ink font-bold text-xs md:text-xl py-3 px-5 md:py-4 md:px-10 rounded-full shadow-[0_10px_30px_rgba(138,110,42,0.45),inset_0_1px_0_rgba(255,255,255,0.5)] border border-[#8A6E2A]/40 transition-all hover:scale-105 active:scale-95 mb-3 md:mb-6 leading-tight cursor-pointer" data-id="element-125">
            🧠 QUIERO DEJAR DE IMPROVISAR EN SESIÓN
          </a>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 md:gap-5 text-[11px] md:text-sm text-muted font-medium" data-id="element-126">
            <div className="flex items-center" data-id="element-127">
              <Lock className="w-3 h-3 md:w-4 md:h-4 mr-1 text-success" data-id="element-128" />{' '}
              Acceso inmediato
            </div>
            <div className="flex items-center" data-id="element-129">
              <Shield className="w-3 h-3 md:w-4 md:h-4 mr-1 text-success" data-id="element-130" />{' '}
              Garantía 7 días
            </div>
            <div className="flex items-center" data-id="element-131">
              <CreditCard className="w-3 h-3 md:w-4 md:h-4 mr-1 text-success" data-id="element-132" />{' '}
              Pago seguro
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}